import { ArbitrageFiltersProvider, MarkAsReadCryptoProvider } from './context';
import { UpdatesProvider } from './context/updatesContext';

interface Props {
  children: React.ReactNode;
}

export const ArbitrageProviders = ({ children }: Props) => {
  return (
    <UpdatesProvider>
      <ArbitrageFiltersProvider>
        <MarkAsReadCryptoProvider>{children}</MarkAsReadCryptoProvider>
      </ArbitrageFiltersProvider>
    </UpdatesProvider>
  );
};
